import { html } from "lit";

/**
 * the list of countries as rendered by TYPO3
 * @param legacy use the old class name
 * @returns Template
 */
export const countryList = (legacy: boolean) => {
    return html`
        <ul class="row ${legacy ? "ux-iws-location-map__locations" : ""}">
            <li class="ux-u-w-50 ux-u-d-inline-block ux-u-p-zero">
                <div
                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-border-bottom"
                >
                    Europa
                </div>
                <ul class="">
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/spain/"
                            >Spanien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/austria/"
                            >Österreich</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/france/"
                            >Frankreich</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/germany/"
                            >Deutschland</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/croatia/"
                            >Kroatien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/ireland/"
                            >Irland</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/netherlands/"
                            >Niederlande</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/finland/"
                            >Finnland</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/latvia/"
                            >Lettland</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/lithuania/"
                            >Litauen</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/estonia/"
                            >Estland</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/poland/"
                            >Polen</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/italy/"
                            class="is-active"
                            >Italien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/norway/"
                            >Norwegen</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/switzerland/"
                            >Schweiz</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/portugal/"
                            >Portugal</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/hungary/"
                            >Ungarn</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/greece/"
                            >Griechenland</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/slovakia/"
                            >Slowakei</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/romania/"
                            >Rumänien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/denmark/"
                            >Dänemark</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/luxembourg/"
                            >Luxemburg</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/slovenia/"
                            >Slowenien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/serbia/"
                            >Serbien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/united-kingdom/"
                            >Großbritannien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/belarus/"
                            >Weißrussland</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/ukraine/"
                            >Ukraine</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/belgium/"
                            >Belgien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/bulgaria/"
                            >Bulgarien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/russia/"
                            >Russische Föderation</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/sweden/"
                            >Schweden</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/czech-republic/"
                            >Tschechische Republik</a
                        >
                    </li>
                </ul>
            </li>
            <li class="ux-u-w-50 ux-u-d-inline-block ux-u-p-zero">
                <div
                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-border-bottom"
                >
                    Asien
                </div>
                <ul>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/philippines/"
                            >Philippinen</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/india/"
                            >Indien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/afghanistan/"
                            >Afghanistan</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/japan/"
                            >Japan</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/israel/"
                            >Israel</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/malaysia/"
                            >Malaysia</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/thailand/"
                            >Thailand</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/indonesia/"
                            >Indonesien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/kuwait/"
                            >Kuwait</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/qatar/"
                            >Katar</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/china/"
                            >China</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/georgia/"
                            >Georgien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/south-korea/"
                            >Republik Korea</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/united-arab-emirates/"
                            >Vereinigte Arabische Emirate</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/saudi-arabia/"
                            >Saudi-Arabien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/turkey/"
                            >Türkei</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/vietnam/"
                            >Vietnam</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/singapore/"
                            >Singapur</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/taiwan/"
                            >Taiwan</a
                        >
                    </li>
                </ul>
            </li>
            <li class="ux-u-w-50 ux-u-d-inline-block ux-u-p-zero">
                <div
                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-border-bottom"
                >
                    Nord-, Mittel- und Südamerika
                </div>
                <ul>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/venezuela/"
                            >Venezuela</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/argentina/"
                            >Argentinien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/colombia/"
                            >Kolumbien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/united-states/"
                            >Vereinigte Staaten von Amerika</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/costa-rica/"
                            >Costa Rica</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/mexico/"
                            >Mexiko</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/peru/"
                            >Peru</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/chile/"
                            >Chile</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/brazil/"
                            >Brasilien</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/canada/"
                            >Kanada</a
                        >
                    </li>
                </ul>
            </li>
            <li class="ux-u-w-50 ux-u-d-inline-block ux-u-p-zero">
                <div
                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-border-bottom"
                >
                    Ozeanien
                </div>
                <ul>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/new-zealand/"
                            >Neuseeland</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/australia/"
                            >Australien</a
                        >
                    </li>
                </ul>
            </li>
            <li class="ux-u-w-50 ux-u-d-inline-block ux-u-p-zero">
                <div
                    class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-border-bottom"
                >
                    Afrika
                </div>
                <ul>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/egypt/"
                            >Ägypten</a
                        >
                    </li>
                    <li>
                        <a
                            href="/de_INT/unternehmen/trumpf-gruppe/standorte/country/south-africa/"
                            >Südafrika</a
                        >
                    </li>
                </ul>
            </li>
        </ul>
    `;
};
